import React from "react";

interface KnockPMSIconProps {
    width?: number;
    height?: number;
    fillColor?: string;
    strokeColor?: string;
}

const KnockPMSIcon = ({
    width = 48,
    height = 48,
    fillColor = "#6366F1",
    strokeColor = "white",
}: KnockPMSIconProps) => {
    return (
        <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" rx="8" fill="#EEF2FF" />
            {/* Clean "K" letter - vertical stem + upper/lower diagonals */}
            <path
                d="M18 14v20M18 24l12-10M18 24l12 10"
                stroke={fillColor}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </svg>
    );
};

export default KnockPMSIcon;
